export enum CommonInternalWorkType {
    USE = "USE",
    REPAIR = "REPAIR",
    PAUSE = "PAUSE",
    OTHER = "OTHER",
}
